export type FORM_FILTERS =
  | 'SUBTITLED'
  | 'AUDIO_DESCRIPTION'
  | 'AUTISM_FRIENDLY'
  | 'DEMENTIA_FRIENDLY'
  | 'WHEELCHAIR_ACCESSIBLE';

// Form filter -> the Athena showtime accessibility tag(s) it should match, used to
// build the `tags:{in:[...]}` / `showtimeTags:{in:[...]}` filter on showtime queries.
// (Replaces the old single-enum `showtimesFilter`.) SUBTITLED covers both the
// subtitled and open-caption tags seen in GB data.
export const FORM_FILTERS_TO_SHOWTIME_TAGS: { [key in FORM_FILTERS]: string[] } = {
  SUBTITLED: [
    'Showtime.Accessibility.Subtitled',
    'Showtime.Accessibility.OpenCaption',
    'Showtime.Accessibility.ClosedCaption',
  ],
  AUDIO_DESCRIPTION: ['Showtime.Accessibility.AudioDescription'],
  AUTISM_FRIENDLY: ['Showtime.Accessibility.AutismFriendly'],
  DEMENTIA_FRIENDLY: ['Showtime.Accessibility.DementiaFriendly'],
  WHEELCHAIR_ACCESSIBLE: ['Showtime.Accessibility.Accessible'],
};

export const getShowtimeTags = (formFilter: string): string[] =>
  Object.prototype.hasOwnProperty.call(FORM_FILTERS_TO_SHOWTIME_TAGS, formFilter)
    ? FORM_FILTERS_TO_SHOWTIME_TAGS[formFilter as FORM_FILTERS]
    : [];

// Athena showtime `attributes` value -> form filter, used to render the per-showtime
// accessibility icons (film-results-item). Athena returns true dotted strings, so
// these keys are the dotted form (no dot->underscore mangling like the old API).
export const API_TAGS_TO_FORM_FILTERS: { [tag: string]: FORM_FILTERS } = {
  'Showtime.Accessibility.AudioDescription': 'AUDIO_DESCRIPTION',
  'Showtime.Accessibility.Subtitled': 'SUBTITLED',
  'Showtime.Accessibility.OpenCaption': 'SUBTITLED',
  'Showtime.Accessibility.ClosedCaption': 'SUBTITLED',
  'Showtime.Accessibility.AutismFriendly': 'AUTISM_FRIENDLY',
  'Showtime.Accessibility.DementiaFriendly': 'DEMENTIA_FRIENDLY',
  'Showtime.Accessibility.Accessible': 'WHEELCHAIR_ACCESSIBLE',
};
